/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: false, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hola 👋.",
  title2: "Anandha Krishnan",
  logo_name: "{ ! }",
  nickname: "Anandhu",
  full_name: "Anandha Krishnan",
  subTitle:
    "An independent and self-motivated computer science undergraduate student with strong Problem Solving and Web development skills.",
  resumeLink:
    "https://drive.google.com/file/d/1dGodVzCi0bBCgb5U5hjNKeZ88H-ALXUo/view?usp=sharing",
  mail: "mailto:anandhu4310@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/anandhu720",
  linkedin: "https://www.linkedin.com/in/anandha-krishnan-8077551b8/",
  gmail: "anandhu4310@gmail.com",
  // gitlab: "https://gitlab.com/harikanani",
  // facebook: "https://www.facebook.com/harikrishan.kanani/",
  // twitter: "https://twitter.com/Harikrushn9",
  instagram: "https://www.instagram.com/_a_na_nadhu__/",
};

const skills = {
  data: [
    {
      title: "Full Stack Developer",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop highly interactive Front end / User Interfaces for your web applications",
        "⚡ Building responsive website front end using ReactJS",
        "⚡ Highly skilled in ReactJs and Redux",
        "⚡ Creating application backend in Node and Express",
        "⚡ Integration of third party services such as Firebase",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "Solidity",
          fontAwesomeClassname: "simple-icons:solidity",
          style: {
            color: "#0865A6",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Ethereum",
          fontAwesomeClassname: "simple-icons:ethereum",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#3776AB",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Lovely Professional University",
      subtitle: "Bachelor in Computer Science and Engineering (Hons)",
      logo_path: "lpu.png",
      alt_name: "LPU",
      duration: "2020 - Present",
      descriptions: [
        "⚡ I'm currently pursuing my bachelors in Computer Science and Engineering.",
        "⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.",
        "⚡ I have also completed various online courses for Backend , Web Development, etc.",
        "⚡ I have implemented several projects based on what I've leart under my Computer Engineering course. ",
      ],
      website_link: "http://www.lpu.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Complete Web Development Bootcamp",
      subtitle: "Udemy",
      logo_path: "web.jpeg",
      certificate_link:
        "https://www.udemy.com/certificate/UC-178af4c1-5ff5-4a8f-98ac-7f289ab2532e/",
      alt_name: "Udemy",
      color_code: "#2AAFED",
      // color_code: "#47A048",
    },
    {
      title: "Mastering Data Structures and Algorithm in C++",
      subtitle: "Udemy",
      logo_path: "dsa.jpeg",
      certificate_link:
        "https://www.udemy.com/certificate/UC-05abb5b9-b955-438b-a904-bb3df7bf1066/",
      alt_name: "Udemy",
      color_code: "#E2405F",
    },
    {
      title: "Ethereum and Solidity",
      subtitle: "Udemy",
      logo_path: "blockchain.jpeg",
      certificate_link:
        "https://www.udemy.com/certificate/UC-4dd064e9-4133-4aa8-adbb-cd934fae747d/",
      alt_name: "Udemy",
      // color_code: "#F6B808",
      color_code: "#47A048",
    },
    {
      title: "IPFS and Decentralised Networking",
      subtitle: "Udemy",
      logo_path: "ipfs.jpeg",
      certificate_link:
        "https://www.udemy.com/certificate/UC-c332526d-ab9f-4e29-b9f7-9a4a4a8c52e5/",
      alt_name: "Udemy",
      // color_code: "#F6B808",
      color_code: "#47A048",
    },

    // color_code: "#8C151599",
    // color_code: "#7A7A7A",
    // color_code: "#0C9D5899",
    // color_code: "#C5E2EE",
    // color_code: "#ffc475",
    // color_code: "#g",
    // color_code: "#ffbfae",
    // color_code: "#fffbf3",
    // color_code: "#b190b0",
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I've mostly done projects on my own and I am actively looking for internships. I love organizing workshops to share my knowledge with others.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Technical Member",
          company: "Google Developer Club - LPU",
          company_url: "https://gdg.community.dev/",
          logo_path: "gdg.png",
          duration: "Aug 2021 - Present",
          location: "LPU - Jalandar",
          description:
            "Developer Student Club - LPU is a university-based community group for students interested in Google technologies. By joining a DSC, students grow their knowledge in a peer-to-peer learning environment and build solutions for local businesses and their community.I'm actively volunteering for Developer Student Club - LPU. Where I help my fellow mates, junior's to be updated with the latest Technical Things.",
          color: "#D83B01",
        },
        {
          title: "Supervisor",
          company: "GirlScript Winter of Contributing",
          company_url: "https://gwoc.girlscript.tech/",
          logo_path: "gwoc.png",
          duration: "Sep 2021 - Dec 2021",
          location: "Online",
          description:
            "GirlScript Winter of Contributing is a three-month newly established initiative by GirlScript Foundation to be conducted during winters. GWOC encourages individuals to share their knowledge and ideas to develop technical skills and gain valuable experience in the field of tech education. Over the course of the program, participants can contribute to a variety of themes under the guidance of an expert facilitator.I am actively supervising the Frontend with Framework part of this Open Source Project.",
          color: "#5a900f",
        },
        {
          title: "Head of Web Development",
          company: "Skillanta",
          company_url: "",
          logo_path: "skillanta.jpeg",
          duration: "May 2021 - present",
          location: "LPU - Jalandar",
          description:
            "I'm actively volunteering for Skillanta as Web Development head. Where I help my fellow mates, junior's to be updated and enhance their skills in Web development",
          color: "#5a900f",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of a vast variety of latest technology tools. My best experience is to create NodeJS Backend Projects, Solidity,ReactJs-Redux and React-native Project. Below are some of my projects. Note that not all of the mentioned projects are on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "me1.jpg",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I don't blog frequently but when I do something awesome, I do try to document it so it can be helpful to others. I write on Twitter.",
    link: "https://twitter.com/Harikrushn9",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      id: "0",
      name: "Crowd Funding D-App Prototype",
      url: "https://github.com/anandhu720/Crowd-Funding-Web-App-Prototype",
      description:
        "D-App prototype made using ethereum blockchain for secure crowd funding.",
      languages: [
        {
          name: "Solidity",
          iconifyClass: "logos-solidity",
        },
        {
          name: "NextJS",
          iconifyClass: "logos-nextjs",
        },
        {
          name: "Web3.js",
          iconifyClass: "logos-web3js",
        },
        {
          name: "Ethereum",
          iconifyClass: "logos-ethereum",
        },
      ],
    },
    {
      id: "1",
      name: "CPU Scheduling Solver",
      url: "https://github.com/anandhu720/CPU-Scheduling-Visualizer",
      description:
        "It is a cpu scheduling algorithm solver and visulaizer made using React-Js and Redux.",
      languages: [
        {
          name: "ReactJs",
          iconifyClass: "logos-react",
        },
        {
          name: "Redux",
          iconifyClass: "logos-redux",
        },
        {
          name: "Sass",
          iconifyClass: "logos-sass",
        },
      ],
    },
    {
      id: "2",
      name: "News App",
      url: "https://github.com/anandhu720/News-Mobile-App",
      description:
        "News App , which updates and shows the latest news happening in India from different National and International News channel websites",
      languages: [
        {
          name: "React-Native",
          iconifyClass: "logos-react",
        },
        {
          name: "Expo cli",
          iconifyClass: "logos-expo",
        },
        {
          name: "Material UI",
          iconifyClass: "logos-material-ui",
        },
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
      ],
    },
    {
      id: "3",
      name: "Memories Web App",
      url: "https://github.com/anandhu720/Memories-Web-App",
      description:
        "Memories Card APP is a MERN web application , which is mobile-responsive also, as I told I mainly used mongoDB , Express , ReactJS , NodeJS for building it.",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "NodeJs",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "Mongodb",
          iconifyClass: "logos-mongodb",
        },
      ],
    },
    {
      id: "4",
      name: "Youtube Web App Clone",
      url: "https://github.com/anandhu720/Youtube-Clone-Web-App",
      description:
        "Youtube clone web-app created using ReactJs, Firebase and Redux.",
      languages: [
        {
          name: "ReactJs",
          iconifyClass: "logos-react",
        },
        {
          name: "Redux",
          iconifyClass: "logos-redux",
        },
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
      ],
    },
    {
      id: "5",
      name: "Hotstar UI clone",
      url: "https://github.com/anandhu720/Hotstar-Web-App-Clone",
      description: "Hotstar-Disney+ UI clone using ReactJS      ",
      languages: [
        {
          name: "ReactJs",
          iconifyClass: "logos-react",
        },
      ],
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
